"use client";

import { type ComponentPropsWithoutRef } from "react";

import { ThemeProvider } from "next-themes";

interface ThemeProviderProps extends ComponentPropsWithoutRef<typeof ThemeProvider> {}
const ThemeProviderDecorators = (props: ThemeProviderProps) => {
  const { children, ...themeProviderProps } = props;

  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      {...themeProviderProps}
    >
      {children}
    </ThemeProvider>
  );
};

export { ThemeProviderDecorators };
